import React, { useEffect } from 'react';
import { initMetaPixel } from './utils/metaPixel';
import { UrgencyBanner } from './components/UrgencyBanner';
import { Hero } from './components/Hero';
import { InsideLook } from './components/InsideLook';
import { InitialTestimonials, MoreTestimonials } from './components/Testimonials';
import { PainPoints } from './components/PainPoints';
import { PackContents, MethodOverview } from './components/MethodOverview';
import { FAQ } from './components/FAQ';
import { CostComparison } from './components/CostComparison';
import { Guarantee, Footer } from './components/Footer';
import { FloatingNotification } from './components/FloatingNotification';
import { EmotionalClose } from './components/EmotionalClose';
const TransitionPhrase = () => <div className="max-w-3xl mx-auto px-6 py-8 text-center" data-id="element-0" data-mp="2whxcnx635uha">
    <div className="gold-rule mb-4" aria-hidden="true" data-id="element-1" data-mp="28t4m6g88geu2">
      <span className="text-brand-gold text-xs" data-id="element-2" data-mp="23vcm2yxfpmes">◆</span>
    </div>
    <p className="text-xl md:text-3xl font-display italic text-brand-purpleDark/85 leading-relaxed" data-id="element-3" data-mp="23v2sz2h3ez4v">
      La próxima sesión puede ser diferente.
    </p>
  </div>;
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="min-h-screen w-full text-brand-text font-sans selection:bg-brand-gold/25 selection:text-brand-purpleDark" data-id="element-4" data-mp="3rcj2nr9n9f1c">
      <UrgencyBanner data-id="element-5" data-mp="4wyzymxdckh" />
      <main data-id="element-6" data-mp="56mnfkhz7n0">
        <Hero data-id="element-7" data-mp="82j0zgp5o9c" />
        <InsideLook data-id="element-8" data-mp="2zl3bdjx5744s" />
        <PackContents data-id="element-9" data-mp="2zlld2w2kqak3" />
        <InitialTestimonials data-id="element-10" data-mp="2zmeowbge3q93" />
        <PainPoints data-id="element-11" data-mp="2zn6biws0edn8" />
        <MethodOverview data-id="element-12" data-mp="33mowfsjtyoq2" />
        <MoreTestimonials data-id="element-13" data-mp="33lwzadal4ixo" />
        <Guarantee data-id="element-14" data-mp="33n6yj5t6bx5w" />
        <FAQ data-id="element-15" data-mp="33orjc3pos1qk" />
        <CostComparison data-id="element-16" data-mp="38lrp0dimj2h5" />
        <TransitionPhrase data-id="element-17" data-mp="38l8eviz7tido" />
        <EmotionalClose data-id="element-18" data-mp="38l06a3a4kz8a" />
      </main>
      <Footer data-id="element-19" data-mp="38o4fjf2g6l5t" />
      <FloatingNotification data-id="element-20" data-mp="3dkl4ucldv5kh" />
    </div>;
}